<a *ngIf="!updated && !showspinner" matTooltip="{{ 'refreshauth.refreshauthentication' | trans }}"  matTooltipPosition="left" matTooltipShowDelay="500" (click)="refresh()"
   class="cursor-pointer opacity" >
      <span class="material-icons bg-lightgrey p-2 f-24 rounded-circle cursor-pointer text-secondary zoom">
        refresh
      </span>
      <p class="mb-0 pt-1 f-13">{{ 'refreshauth.refreshauthentication' | trans }}</p>
</a>
<a *ngIf="!updated && showspinner" matTooltip="{{ 'refreshauth.pleaseconfirm' | trans }}"  matTooltipPosition="left" matTooltipShowDelay="500" (click)="refresh()"
   class="cursor-pointer opacity" >
      <span class="material-icons bg-lightgrey p-2 f-24 rounded-circle cursor-pointer text-secondary zoom animate-custom">
        refresh
      </span>
      <p class="mb-0 pt-1 f-13">{{ 'refreshauth.refreshauthentication' | trans }}</p>
</a>
<a *ngIf="updated" matTooltip="{{ 'refreshauth.Authenticationrefreshed' | trans }}"  matTooltipPosition="left" matTooltipShowDelay="500" (click)="refresh()"
   class="cursor-pointer opacity">
      <span class="material-icons bg-save p-2 f-24 rounded-circle text-white cursor-pointer zoom">
        check
      </span>
      <p class="mb-0 pt-1 f-13">{{ 'refreshauth.refreshauthentication' | trans }}</p>
</a>